import Comprobante from './Comprobante';

export default Comprobante